import { lazy } from 'react';

export const LazyReport = lazy(() => import('./Report.js'));
